module.exports = {

	"stateCities" : {
		"ANI": [
	        {
	            "id": "744303",
	            "name": "Nicobar"
	        },
	        {
	            "id": "1146883",
	            "name": "PortBlair"
	        }
	    ],
	    "AP": [
	        {
	            "id": "1008101",
	            "name": "Nandyal"
	        },
	        {
	            "id": "1008461",
	            "name": "Narsapur"
	        },
	        {
	            "id": "1008281",
	            "name": "Narasaraopet"
	        },
	        {
	            "id": "534001",
	            "name": "WestGodavari"
	        },
	        {
	            "id": "100169",
	            "name": "Prakasam"
	        },
	        {
	            "id": "1011521",
	            "name": "Samalkota"
	        },
	        {
	            "id": "1011881",
	            "name": "Sattenapalle"
	        },
	        {
	            "id": "1012781",
	            "name": "Srikakulam"
	        },
	        {
	            "id": "1012961",
	            "name": "Srikalahasti"
	        },
	        {
	            "id": "1013321",
	            "name": "Tadepalligudem"
	        },
	        {
	            "id": "1013501",
	            "name": "Tadpatri"
	        },
	        {
	            "id": "1013861",
	            "name": "Tanuku"
	        },
	        {
	            "id": "1014041",
	            "name": "Tenali"
	        },
	        {
	            "id": "1014221",
	            "name": "Tirupati"
	        },
	        {
	            "id": "1014401",
	            "name": "Tuni"
	        },
	        {
	            "id": "1002881",
	            "name": "Eluru"
	        },
	        {
	            "id": "1003421",
	            "name": "Gudivada"
	        },
	        {
	            "id": "1003601",
	            "name": "Gudur"
	        },
	        {
	            "id": "1004861",
	            "name": "Kakinada"
	        },
	        {
	            "id": "1009721",
	            "name": "Pitapuram"
	        },
	        {
	            "id": "1009901",
	            "name": "Ponnur"
	        },
	        {
	            "id": "1010081",
	            "name": "Proddatur"
	        },
	        {
	            "id": "100168",
	            "name": "Krishna"
	        },
	        {
	            "id": "100194",
	            "name": "EastGodavari"
	        },
	        {
	            "id": "1002701",
	            "name": "Dharmavaram"
	        },
	        {
	            "id": "1005581",
	            "name": "Kavali"
	        },
	        {
	            "id": "520001",
	            "name": "Vijayawada"
	        },
	        {
	            "id": "1014761",
	            "name": "Vinukonda"
	        },
	        {
	            "id": "531001",
	            "name": "Vizag"
	        },
	        {
	            "id": "1014941",
	            "name": "Vizianagaram"
	        },
	        {
	            "id": "1015301",
	            "name": "Yemmiganur"
	        },
	        {
	            "id": "1010441",
	            "name": "Rajahmundry"
	        },
	        {
	            "id": "1010801",
	            "name": "Ramachandrapuram"
	        },
	        {
	            "id": "1011161",
	            "name": "Rayachoti"
	        },
	        {
	            "id": "1007561",
	            "name": "Markapur"
	        },
	        {
	            "id": "1003781",
	            "name": "Guntakal"
	        },
	        {
	            "id": "1003961",
	            "name": "Guntur"
	        },
	        {
	            "id": "1004141",
	            "name": "Hindupur"
	        },
	        {
	            "id": "1006301",
	            "name": "Kurnool"
	        },
	        {
	            "id": "524101",
	            "name": "Nellore"
	        },
	        {
	            "id": "1009001",
	            "name": "Nuzvid"
	        },
	        {
	            "id": "1009181",
	            "name": "Ongole"
	        },
	        {
	            "id": "1009361",
	            "name": "Palakol"
	        },
	        {
	            "id": "1004501",
	            "name": "Kadiri"
	        },
	        {
	            "id": "1000181",
	            "name": "Adoni"
	        },
	        {
	            "id": "1000361",
	            "name": "Amalapuram"
	        },
	        {
	            "id": "1000541",
	            "name": "Anakapalle"
	        },
	        {
	            "id": "1000721",
	            "name": "Anantapur"
	        },
	        {
	            "id": "1000901",
	            "name": "Bapatla"
	        },
	        {
	            "id": "1001261",
	            "name": "Bhimavaram"
	        },
	        {
	            "id": "1001441",
	            "name": "Bobbili"
	        },
	        {
	            "id": "1002161",
	            "name": "Chirala"
	        },
	        {
	            "id": "1002341",
	            "name": "Chittoor"
	        },
	        {
	            "id": "1002521",
	            "name": "Cuddapah"
	        },
	        {
	            "id": "1006481",
	            "name": "Machilipatnam"
	        },
	        {
	            "id": "1006661",
	            "name": "Madanapalle"
	        },
	        {
	            "id": "1010801",
	            "name": "Ramachandrapuram"
	        },
	        {
	            "id": "1001261",
	            "name": "Bhimavaram"
	        },
	        {
	            "id": "1003421",
	            "name": "Gudivada"
	        },
	        {
	            "id": "1011341",
	            "name": "Rayadurg"
	        }
	    ],
	    "ARP": [
	        {
	            "id": "791001",
	            "name": "KraDaadi"
	        },
	        {
	            "id": "100206",
	            "name": "WestSiang"
	        },
	        {
	            "id": "790102",
	            "name": "EastKameng"
	        },
	        {
	            "id": "100203",
	            "name": "Tirap"
	        },
	        {
	            "id": "792101",
	            "name": "DibangValley"
	        },
	        {
	            "id": "786631",
	            "name": "Longding"
	        },
	        {
	            "id": "791125",
	            "name": "Siang"
	        },
	        {
	            "id": "100202",
	            "name": "Tawang"
	        },
	        {
	            "id": "100002",
	            "name": "Namsai"
	        },
	        {
	            "id": "100205",
	            "name": "WestKameng"
	        },
	        {
	            "id": "1015481",
	            "name": "Itanagar"
	        },
	        {
	            "id": "792104",
	            "name": "Anjaw"
	        },
	        {
	            "id": "792001",
	            "name": "Lohit"
	        },
	        {
	            "id": "100001",
	            "name": "Changlang"
	        },
	        {
	            "id": "791102",
	            "name": "EastSiang"
	        }
	    ],
	    "AS": [
	        {
	            "id": "100012",
	            "name": "Marigaon"
	        },
	        {
	            "id": "781001",
	            "name": "Guwahati"
	        },
	        {
	            "id": "100009",
	            "name": "Hailakandi"
	        },
	        {
	            "id": "782435",
	            "name": "Hojai"
	        },
	        {
	            "id": "100014",
	            "name": "Sonitpur"
	        },
	        {
	            "id": "100004",
	            "name": "Cachar"
	        },
	        {
	            "id": "1016561",
	            "name": "Jorhat"
	        },
	        {
	            "id": "100003",
	            "name": "Barpeta"
	        },
	        {
	            "id": "1015661",
	            "name": "Bongaigaon"
	        },
	        {
	            "id": "1016921",
	            "name": "Lumding"
	        },
	        {
	            "id": "784509",
	            "name": "Udalguri"
	        },
	        {
	            "id": "100010",
	            "name": "Kamrup"
	        },
	        {
	            "id": "100005",
	            "name": "Darrang"
	        },
	        {
	            "id": "781360",
	            "name": "Baksa"
	        },
	        {
	            "id": "784176",
	            "name": "Biswanath"
	        },
	        {
	            "id": "785102",
	            "name": "Majuli"
	        },
	        {
	            "id": "782486",
	            "name": "WestKarbiAnglong"
	        },
	        {
	            "id": "785686",
	            "name": "Charaideo"
	        },
	        {
	            "id": "1017461",
	            "name": "Silchar"
	        },
	        {
	            "id": "1017821",
	            "name": "Tezpur"
	        },
	        {
	            "id": "1018001",
	            "name": "Tinsukia"
	        },
	        {
	            "id": "100007",
	            "name": "Goalpara"
	        },
	        {
	            "id": "100008",
	            "name": "Golaghat"
	        },
	        {
	            "id": "1017101",
	            "name": "Nagaon"
	        },
	        {
	            "id": "100013",
	            "name": "Nalbari"
	        },
	        {
	            "id": "100011",
	            "name": "Kokrajhar"
	        },
	        {
	            "id": "783385",
	            "name": "Chirang"
	        },
	        {
	            "id": "100006",
	            "name": "Dhemaji"
	        },
	        {
	            "id": "1015841",
	            "name": "Dhubri"
	        },
	        {
	            "id": "1016021",
	            "name": "Dibrugarh"
	        },
	        {
	            "id": "1016201",
	            "name": "Diphu"
	        },
	        {
	            "id": "1016741",
	            "name": "Karimganj"
	        },
	        {
	            "id": "1016741",
	            "name": "Karimganj"
	        },
	        {
	            "id": "784176",
	            "name": "Biswanath"
	        }
	    ],
	    "BI": [
	        {
	            "id": "100016",
	            "name": "Bhojpur"
	        },
	        {
	            "id": "100023",
	            "name": "Saran"
	        },
	        {
	            "id": "1022141",
	            "name": "Motihari"
	        },
	        {
	            "id": "1022321",
	            "name": "Munger"
	        },
	        {
	            "id": "1022681",
	            "name": "Nawada"
	        },
	        {
	            "id": "800001",
	            "name": "Patna"
	        },
	        {
	            "id": "100019",
	            "name": "Khagaria"
	        },
	        {
	            "id": "1021421",
	            "name": "Kishanganj"
	        },
	        {
	            "id": "100018",
	            "name": "Kaimur"
	        },
	        {
	            "id": "844101",
	            "name": "Vaishali"
	        },
	        {
	            "id": "1019801",
	            "name": "DehrionSone"
	        },
	        {
	            "id": "1021241",
	            "name": "Katihar"
	        },
	        {
	            "id": "1023041",
	            "name": "Purnia"
	        },
	        {
	            "id": "1023221",
	            "name": "Saharsa"
	        },
	        {
	            "id": "1023401",
	            "name": "Samastipur"
	        },
	        {
	            "id": "1023581",
	            "name": "Sasaram"
	        },
	        {
	            "id": "100213",
	            "name": "Sheikhpura"
	        },
	        {
	            "id": "100024",
	            "name": "Sheohar"
	        },
	        {
	            "id": "1023761",
	            "name": "Sitamarhi"
	        },
	        {
	            "id": "100025",
	            "name": "Siwan"
	        },
	        {
	            "id": "1023941",
	            "name": "Supaul"
	        },
	        {
	            "id": "1020161",
	            "name": "Gaya"
	        },
	        {
	            "id": "1020341",
	            "name": "Gopalganj"
	        },
	        {
	            "id": "100021",
	            "name": "Nalanda"
	        },
	        {
	            "id": "1022501",
	            "name": "Muzaffarpur"
	        },
	        {
	            "id": "1018181",
	            "name": "Araria"
	        },
	        {
	            "id": "1018361",
	            "name": "Arrah"
	        },
	        {
	            "id": "1018541",
	            "name": "Bagaha"
	        },
	        {
	            "id": "100015",
	            "name": "Banka"
	        },
	        {
	            "id": "1018721",
	            "name": "Begusarai"
	        },
	        {
	            "id": "1018901",
	            "name": "Bettiah"
	        },
	        {
	            "id": "1019081",
	            "name": "Bhagalpur"
	        },
	        {
	            "id": "1019261",
	            "name": "Buxar"
	        },
	        {
	            "id": "1019441",
	            "name": "Chapra"
	        },
	        {
	            "id": "1019621",
	            "name": "Darbhanga"
	        },
	        {
	            "id": "1021601",
	            "name": "Lakhisarai"
	        },
	        {
	            "id": "100020",
	            "name": "Madhepura"
	        },
	        {
	            "id": "1021781",
	            "name": "Madhubani"
	        },
	        {
	            "id": "1020701",
	            "name": "Jamalpur"
	        },
	        {
	            "id": "1020881",
	            "name": "Jamui"
	        },
	        {
	            "id": "1021061",
	            "name": "Jehanabad"
	        },
	        {
	            "id": "804401",
	            "name": "Arwal"
	        },
	        {
	            "id": "845438",
	            "name": "WestChamparan"
	        },
	        {
	            "id": "100022",
	            "name": "Rohtas"
	        },
	        {
	            "id": "1020701",
	            "name": "Jamalpur"
	        },
	        {
	            "id": "1022681",
	            "name": "Nawada"
	        },
	        {
	            "id": "100019",
	            "name": "Khagaria"
	        },
	        {
	            "id": "1018361",
	            "name": "Arrah"
	        }
	    ],
	    "C": [
	        {
	            "id": "24",
	            "name": "Chandigarh"
	        }
	    ],
	    "CHH": [
	        {
	            "id": "1026101",
	            "name": "Raipur"
	        },
	        {
	            "id": "1026281",
	            "name": "RajNandgaon"
	        },
	        {
	            "id": "497229",
	            "name": "Surajpur"
	        },
	        {
	            "id": "100030",
	            "name": "Surguja"
	        },
	        {
	            "id": "494111",
	            "name": "Sukma"
	        },
	        {
	            "id": "100027",
	            "name": "Jashpur"
	        },
	        {
	            "id": "493889",
	            "name": "Gariaband"
	        },
	        {
	            "id": "100026",
	            "name": "Bastar"
	        },
	        {
	            "id": "491995",
	            "name": "Kabirdham"
	        },
	        {
	            "id": "1024121",
	            "name": "Ambikapur"
	        },
	        {
	            "id": "491226",
	            "name": "Balod"
	        },
	        {
	            "id": "493332",
	            "name": "BalodaBazarBhatapara"
	        },
	        {
	            "id": "1024301",
	            "name": "Bhatapara"
	        },
	        {
	            "id": "1024481",
	            "name": "Bhilai"
	        },
	        {
	            "id": "1024841",
	            "name": "Chirmiri"
	        },
	        {
	            "id": "494449",
	            "name": "Dantewada"
	        },
	        {
	            "id": "100029",
	            "name": "Mahasamund"
	        },
	        {
	            "id": "1025561",
	            "name": "Jagdalpur"
	        },
	        {
	            "id": "494661",
	            "name": "Narayanpur"
	        },
	        {
	            "id": "494226",
	            "name": "Kondagaon"
	        },
	        {
	            "id": "1025741",
	            "name": "Korba"
	        },
	        {
	            "id": "495334",
	            "name": "Mungeli"
	        },
	        {
	            "id": "1025381",
	            "name": "Durg"
	        },
	        {
	            "id": "1025201",
	            "name": "Dhamtari"
	        },
	        {
	            "id": "100028",
	            "name": "Kanker"
	        },
	        {
	            "id": "100217",
	            "name": "Kawardha"
	        },
	        {
	            "id": "493332",
	            "name": "BalodaBazarBhatapara"
	        },
	        {
	            "id": "494661",
	            "name": "Narayanpur"
	        },
	        {
	            "id": "493332",
	            "name": "BalodaBazarBhatapara"
	        },
	        {
	            "id": "1024121",
	            "name": "Ambikapur"
	        }
	    ],
	    "DNH": [
	        {
	            "id": "1026461",
	            "name": "Silvassa"
	        },
	        {
	            "id": "396193",
	            "name": "DadraandNagarHaveli"
	        }
	    ],
	    "DND": [
	        {
	            "id": "1026641",
	            "name": "Daman"
	        },
	        {
	            "id": "1026821",
	            "name": "Diu"
	        }
	    ],
	    "D": [
	        {
	            "id": "27",
	            "name": "Delhi"
	        }
	    ],
	    "GOA": [
	        {
	            "id": "1027361",
	            "name": "Panaji"
	        }
	    ],
	    "GJ": [
	        {
	            "id": "1032221",
	            "name": "Kalol"
	        },
	        {
	            "id": "383350",
	            "name": "Aravalli"
	        },
	        {
	            "id": "360001",
	            "name": "Rajkot"
	        },
	        {
	            "id": "100201",
	            "name": "Rajpipla"
	        },
	        {
	            "id": "1035281",
	            "name": "Savarkundla"
	        },
	        {
	            "id": "1035461",
	            "name": "Sidhpur"
	        },
	        {
	            "id": "182222",
	            "name": "Surat"
	        },
	        {
	            "id": "361335",
	            "name": "Dwarka"
	        },
	        {
	            "id": "1030781",
	            "name": "Gandhidham"
	        },
	        {
	            "id": "382010",
	            "name": "Gandhinagar"
	        },
	        {
	            "id": "1031141",
	            "name": "Godhra"
	        },
	        {
	            "id": "1031321",
	            "name": "Gondal"
	        },
	        {
	            "id": "1033841",
	            "name": "Nadiad"
	        },
	        {
	            "id": "1036001",
	            "name": "Unjha"
	        },
	        {
	            "id": "1036181",
	            "name": "Upleta"
	        },
	        {
	            "id": "390001",
	            "name": "Vadodara"
	        },
	        {
	            "id": "1036361",
	            "name": "Valsad"
	        },
	        {
	            "id": "1036541",
	            "name": "Vapi"
	        },
	        {
	            "id": "388255",
	            "name": "Mahisagar"
	        },
	        {
	            "id": "370210",
	            "name": "Kandla"
	        },
	        {
	            "id": "1032581",
	            "name": "Khambhat"
	        },
	        {
	            "id": "387411",
	            "name": "Kheda"
	        },
	        {
	            "id": "1034741",
	            "name": "Petlad"
	        },
	        {
	            "id": "1034921",
	            "name": "Porbandar"
	        },
	        {
	            "id": "100032",
	            "name": "Panchmahal"
	        },
	        {
	            "id": "385001",
	            "name": "Banaskantha"
	        },
	        {
	            "id": "393145",
	            "name": "Narmada"
	        },
	        {
	            "id": "100031",
	            "name": "Kutch"
	        },
	        {
	            "id": "1030061",
	            "name": "Deesa"
	        },
	        {
	            "id": "1030241",
	            "name": "Dholka"
	        },
	        {
	            "id": "1030421",
	            "name": "Dhoraji"
	        },
	        {
	            "id": "1030601",
	            "name": "Dhrangadhra"
	        },
	        {
	            "id": "1032401",
	            "name": "Keshod"
	        },
	        {
	            "id": "1036901",
	            "name": "Veraval"
	        },
	        {
	            "id": "1037081",
	            "name": "Vijalpor"
	        },
	        {
	            "id": "1037261",
	            "name": "Viramgam"
	        },
	        {
	            "id": "1037441",
	            "name": "Visnagar"
	        },
	        {
	            "id": "1032761",
	            "name": "Mahuva"
	        },
	        {
	            "id": "1032941",
	            "name": "Mandvi"
	        },
	        {
	            "id": "1031501",
	            "name": "Himatnagar"
	        },
	        {
	            "id": "361001",
	            "name": "Jamnagar"
	        },
	        {
	            "id": "1029881",
	            "name": "Dahod"
	        },
	        {
	            "id": "1035641",
	            "name": "Surendranagar"
	        },
	        {
	            "id": "394635",
	            "name": "Tapi"
	        },
	        {
	            "id": "1033301",
	            "name": "Mehsana"
	        },
	        {
	            "id": "1033661",
	            "name": "Morbi"
	        },
	        {
	            "id": "383001",
	            "name": "Sabarkantha"
	        },
	        {
	            "id": "1033481",
	            "name": "Modasa"
	        },
	        {
	            "id": "1034021",
	            "name": "Navsari"
	        },
	        {
	            "id": "1034201",
	            "name": "Palanpur"
	        },
	        {
	            "id": "1034381",
	            "name": "Palitana"
	        },
	        {
	            "id": "1031861",
	            "name": "Junagadh"
	        },
	        {
	            "id": "1032041",
	            "name": "Kadi"
	        },
	        {
	            "id": "22",
	            "name": "Ahmedabad"
	        },
	        {
	            "id": "1027541",
	            "name": "Amreli"
	        },
	        {
	            "id": "1027721",
	            "name": "Anand"
	        },
	        {
	            "id": "1027901",
	            "name": "Anjar"
	        },
	        {
	            "id": "1028081",
	            "name": "Ankleshwar"
	        },
	        {
	            "id": "1028261",
	            "name": "Bardoli"
	        },
	        {
	            "id": "393110",
	            "name": "Bharuch"
	        },
	        {
	            "id": "1028441",
	            "name": "Bhavnagar"
	        },
	        {
	            "id": "1028621",
	            "name": "Bhuj"
	        },
	        {
	            "id": "1028801",
	            "name": "Bilimora"
	        },
	        {
	            "id": "1028981",
	            "name": "Borsad"
	        },
	        {
	            "id": "1029161",
	            "name": "Botad"
	        },
	        {
	            "id": "1029701",
	            "name": "Dabhoi"
	        },
	        {
	            "id": "1035821",
	            "name": "Una"
	        },
	        {
	            "id": "1029341",
	            "name": "Chandkheda"
	        },
	        {
	            "id": "362150",
	            "name": "GirSomnath"
	        },
	        {
	            "id": "385001",
	            "name": "Banaskantha"
	        },
	        {
	            "id": "1031321",
	            "name": "Gondal"
	        }
	    ],
	    "HA": [
	        {
	            "id": "1041042",
	            "name": "Tohana"
	        },
	        {
	            "id": "121001",
	            "name": "Faridabad"
	        },
	        {
	            "id": "1039601",
	            "name": "Narnaul"
	        },
	        {
	            "id": "1039781",
	            "name": "Narwana"
	        },
	        {
	            "id": "122103",
	            "name": "Mewat"
	        },
	        {
	            "id": "1038881",
	            "name": "Jind"
	        },
	        {
	            "id": "1039061",
	            "name": "Kaithal"
	        },
	        {
	            "id": "136118",
	            "name": "Kurukshetra"
	        },
	        {
	            "id": "1038701",
	            "name": "Jagadhri"
	        },
	        {
	            "id": "123106",
	            "name": "Dharuhera"
	        },
	        {
	            "id": "1039241",
	            "name": "Karnal"
	        },
	        {
	            "id": "1041222",
	            "name": "Yamunanagar"
	        },
	        {
	            "id": "1040322",
	            "name": "Rewari"
	        },
	        {
	            "id": "1040502",
	            "name": "Rohtak"
	        },
	        {
	            "id": "1040682",
	            "name": "Sonipat"
	        },
	        {
	            "id": "1040862",
	            "name": "Thanesar"
	        },
	        {
	            "id": "1037621",
	            "name": "Ambala"
	        },
	        {
	            "id": "1037981",
	            "name": "Bahadurgarh"
	        },
	        {
	            "id": "1038161",
	            "name": "Bhiwani"
	        },
	        {
	            "id": "132222",
	            "name": "Gurgaon"
	        },
	        {
	            "id": "1038521",
	            "name": "Hansi"
	        },
	        {
	            "id": "125001",
	            "name": "Hisar"
	        },
	        {
	            "id": "124103",
	            "name": "Jhajjar"
	        },
	        {
	            "id": "1039961",
	            "name": "Palwal"
	        },
	        {
	            "id": "134102",
	            "name": "Panchkula"
	        },
	        {
	            "id": "1040142",
	            "name": "Panipat"
	        },
	        {
	            "id": "1037981",
	            "name": "Bahadurgarh"
	        }
	    ],
	    "HP": [
	        {
	            "id": "173209",
	            "name": "Dharampur"
	        },
	        {
	            "id": "100040",
	            "name": "Nahan"
	        },
	        {
	            "id": "176036",
	            "name": "Kangra"
	        },
	        {
	            "id": "173204",
	            "name": "Kasauli"
	        },
	        {
	            "id": "171206",
	            "name": "Shimla"
	        },
	        {
	            "id": "173215",
	            "name": "Solan"
	        },
	        {
	            "id": "176304",
	            "name": "Dalhousie"
	        },
	        {
	            "id": "175131",
	            "name": "Manali"
	        },
	        {
	            "id": "100039",
	            "name": "Mandi"
	        },
	        {
	            "id": "100037",
	            "name": "Kinnaur"
	        },
	        {
	            "id": "175101",
	            "name": "Kullu"
	        },
	        {
	            "id": "100041",
	            "name": "Sirmaur"
	        }
	    ],
	    "JK": [
	        {
	            "id": "194101",
	            "name": "Leh"
	        },
	        {
	            "id": "180001",
	            "name": "Jammu"
	        },
	        {
	            "id": "1041942",
	            "name": "Sopore"
	        },
	        {
	            "id": "190001",
	            "name": "Srinagar"
	        },
	        {
	            "id": "191201",
	            "name": "Ganderbal"
	        },
	        {
	            "id": "1042122",
	            "name": "Udhampur"
	        },
	        {
	            "id": "100046",
	            "name": "Poonch"
	        },
	        {
	            "id": "192305",
	            "name": "Shopian"
	        },
	        {
	            "id": "100042",
	            "name": "Budgam"
	        },
	        {
	            "id": "192231",
	            "name": "Kulgam"
	        },
	        {
	            "id": "100045",
	            "name": "Kupwara"
	        },
	        {
	            "id": "182204",
	            "name": "Kishtwar"
	        },
	        {
	            "id": "100047",
	            "name": "Pulwama"
	        },
	        {
	            "id": "1041762",
	            "name": "Kathua"
	        },
	        {
	            "id": "100043",
	            "name": "Doda"
	        },
	        {
	            "id": "100044",
	            "name": "Kargil"
	        },
	        {
	            "id": "1041762",
	            "name": "Kathua"
	        },
	        {
	            "id": "100048",
	            "name": "Rajouri"
	        },
	        {
	            "id": "182144",
	            "name": "Ramban"
	        },
	        {
	            "id": "182311",
	            "name": "Reasi"
	        },
	        {
	            "id": "100049",
	            "name": "Samba"
	        },
	        {
	            "id": "1041402",
	            "name": "Anantnag"
	        },
	        {
	            "id": "193502",
	            "name": "Bandipora"
	        },
	        {
	            "id": "1041582",
	            "name": "Baramulla"
	        }
	    ],
	    "JHA": [
	        {
	            "id": "1045722",
	            "name": "Sindri"
	        },
	        {
	            "id": "100062",
	            "name": "SeraikelaKharsawan"
	        },
	        {
	            "id": "100063",
	            "name": "Simdega"
	        },
	        {
	            "id": "100051",
	            "name": "Dumka"
	        },
	        {
	            "id": "100052",
	            "name": "Garhwa"
	        },
	        {
	            "id": "1043922",
	            "name": "Giridih"
	        },
	        {
	            "id": "100017",
	            "name": "Godda"
	        },
	        {
	            "id": "100053",
	            "name": "Gumla"
	        },
	        {
	            "id": "100060",
	            "name": "WestSinghbhum"
	        },
	        {
	            "id": "1042842",
	            "name": "BokaroSteelCity"
	        },
	        {
	            "id": "100056",
	            "name": "Koderma"
	        },
	        {
	            "id": "100062",
	            "name": "SeraikelaKharsawan"
	        },
	        {
	            "id": "832404",
	            "name": "Khunti"
	        },
	        {
	            "id": "1045002",
	            "name": "Phusro"
	        },
	        {
	            "id": "1043742",
	            "name": "Deoghar"
	        },
	        {
	            "id": "826001",
	            "name": "Dhanbad"
	        },
	        {
	            "id": "1045182",
	            "name": "Ramgarh"
	        },
	        {
	            "id": "834002",
	            "name": "Ranchi"
	        },
	        {
	            "id": "100061",
	            "name": "Sahibganj"
	        },
	        {
	            "id": "1045542",
	            "name": "Saunda"
	        },
	        {
	            "id": "1043022",
	            "name": "Chaibasa"
	        },
	        {
	            "id": "1043202",
	            "name": "Chakradharpur"
	        },
	        {
	            "id": "100050",
	            "name": "Chatra"
	        },
	        {
	            "id": "1043382",
	            "name": "Chirkunda"
	        },
	        {
	            "id": "1043562",
	            "name": "Daltonganj"
	        },
	        {
	            "id": "100057",
	            "name": "Latehar"
	        },
	        {
	            "id": "100058",
	            "name": "Lohardaga"
	        },
	        {
	            "id": "1044102",
	            "name": "Hazaribag"
	        },
	        {
	            "id": "831001",
	            "name": "Jamshedpur"
	        },
	        {
	            "id": "100055",
	            "name": "Jamtara"
	        },
	        {
	            "id": "100058",
	            "name": "Lohardaga"
	        },
	        {
	            "id": "100054",
	            "name": "Hazaribagh"
	        },
	        {
	            "id": "100058",
	            "name": "Lohardaga"
	        },
	        {
	            "id": "1044462",
	            "name": "JhumriTelaiya"
	        },
	        {
	            "id": "1043382",
	            "name": "Chirkunda"
	        }
	    ],
	    "KA": [
	        {
	            "id": "1046802",
	            "name": "Bidar"
	        },
	        {
	            "id": "1049322",
	            "name": "Gulbarga"
	        },
	        {
	            "id": "580020",
	            "name": "Hubli"
	        },
	        {
	            "id": "1146941",
	            "name": "Dharwad"
	        },
	        {
	            "id": "32",
	            "name": "Mysore"
	        },
	        {
	            "id": "1053822",
	            "name": "Udupi"
	        },
	        {
	            "id": "1048782",
	            "name": "Gadag"
	        },
	        {
	            "id": "1051842",
	            "name": "Raichur"
	        },
	        {
	            "id": "1052022",
	            "name": "Ramanagaram"
	        },
	        {
	            "id": "1052742",
	            "name": "Shimoga"
	        },
	        {
	            "id": "1052922",
	            "name": "Sindhnur"
	        },
	        {
	            "id": "1053102",
	            "name": "Sira"
	        },
	        {
	            "id": "1053462",
	            "name": "Tiptur"
	        },
	        {
	            "id": "1053642",
	            "name": "Tumkur"
	        },
	        {
	            "id": "1049142",
	            "name": "Gokak"
	        },
	        {
	            "id": "100210",
	            "name": "Kadur"
	        },
	        {
	            "id": "1050582",
	            "name": "Karwar"
	        },
	        {
	            "id": "1054002",
	            "name": "Yadgir"
	        },
	        {
	            "id": "100229",
	            "name": "Jamkhandi"
	        },
	        {
	            "id": "1050762",
	            "name": "Kolar"
	        },
	        {
	            "id": "1050942",
	            "name": "Kollegal"
	        },
	        {
	            "id": "1051122",
	            "name": "Koppal"
	        },
	        {
	            "id": "1051122",
	            "name": "Koppal"
	        },
	        {
	            "id": "100231",
	            "name": "Mudhol"
	        },
	        {
	            "id": "1051482",
	            "name": "Nipani"
	        },
	        {
	            "id": "1047702",
	            "name": "Chikmagalur"
	        },
	        {
	            "id": "1047882",
	            "name": "Chintamani"
	        },
	        {
	            "id": "1048062",
	            "name": "Chitradurga"
	        },
	        {
	            "id": "1048242",
	            "name": "Dandeli"
	        },
	        {
	            "id": "1048422",
	            "name": "Davanagere"
	        },
	        {
	            "id": "1051302",
	            "name": "Mandya"
	        },
	        {
	            "id": "575001",
	            "name": "Mangalore"
	        },
	        {
	            "id": "1049502",
	            "name": "Harihar"
	        },
	        {
	            "id": "1049682",
	            "name": "Hassan"
	        },
	        {
	            "id": "1051662",
	            "name": "RabkaviBanhatti"
	        },
	        {
	            "id": "1049862",
	            "name": "Haveri"
	        },
	        {
	            "id": "100228",
	            "name": "Hiriyur"
	        },
	        {
	            "id": "1050042",
	            "name": "Hospet"
	        },
	        {
	            "id": "1050222",
	            "name": "Ilkal"
	        },
	        {
	            "id": "100222",
	            "name": "Arsikere"
	        },
	        {
	            "id": "1046082",
	            "name": "Bagalkot"
	        },
	        {
	            "id": "1046262",
	            "name": "Basavakalyan"
	        },
	        {
	            "id": "590001",
	            "name": "Belgaum"
	        },
	        {
	            "id": "1046442",
	            "name": "Bellary"
	        },
	        {
	            "id": "100239",
	            "name": "Bhatkal"
	        },
	        {
	            "id": "1046802",
	            "name": "Bidar"
	        },
	        {
	            "id": "1046982",
	            "name": "Bijapur"
	        },
	        {
	            "id": "100196",
	            "name": "Challakere"
	        },
	        {
	            "id": "1047342",
	            "name": "Channapatna"
	        },
	        {
	            "id": "1046802",
	            "name": "Bidar"
	        },
	        {
	            "id": "100065",
	            "name": "UttaraKannada"
	        },
	        {
	            "id": "1052022",
	            "name": "Ramanagaram"
	        },
	        {
	            "id": "23",
	            "name": "Bangalore"
	        },
	        {
	            "id": "1052022",
	            "name": "Ramanagaram"
	        },
	        {
	            "id": "1047522",
	            "name": "Chikkaballapur"
	        }
	    ],
	    "KE": [
	        {
	            "id": "1055982",
	            "name": "Kottayam"
	        },
	        {
	            "id": "673003",
	            "name": "Kozhikode"
	        },
	        {
	            "id": "1056522",
	            "name": "Nedumangad"
	        },
	        {
	            "id": "1056702",
	            "name": "Neyyattinkara"
	        },
	        {
	            "id": "1056882",
	            "name": "Palakkad"
	        },
	        {
	            "id": "1056162",
	            "name": "Malappuram"
	        },
	        {
	            "id": "1054182",
	            "name": "Alappuzha"
	        },
	        {
	            "id": "1054542",
	            "name": "Cherthala"
	        },
	        {
	            "id": "100066",
	            "name": "Idukki"
	        },
	        {
	            "id": "1057422",
	            "name": "Taliparamba"
	        },
	        {
	            "id": "689101",
	            "name": "Thiruvalla"
	        },
	        {
	            "id": "685584",
	            "name": "Thodupuzha"
	        },
	        {
	            "id": "680001",
	            "name": "Thrissur"
	        },
	        {
	            "id": "1057782",
	            "name": "Tirur"
	        },
	        {
	            "id": "100067",
	            "name": "Pathanamthitta"
	        },
	        {
	            "id": "29",
	            "name": "Kochi"
	        },
	        {
	            "id": "1057062",
	            "name": "Payyannur"
	        },
	        {
	            "id": "1057242",
	            "name": "Ponnani"
	        },
	        {
	            "id": "673121",
	            "name": "Wayanad"
	        },
	        {
	            "id": "1055082",
	            "name": "Kanhangad"
	        },
	        {
	            "id": "1055262",
	            "name": "Kannur"
	        },
	        {
	            "id": "1055442",
	            "name": "Kasaragod"
	        },
	        {
	            "id": "1055622",
	            "name": "Kayamkulam"
	        },
	        {
	            "id": "1055802",
	            "name": "Kollam"
	        },
	        {
	            "id": "1055262",
	            "name": "Kannur"
	        }
	    ],
	    "LK": [
	        {
	            "id": "1058142",
	            "name": "Kavaratti"
	        }
	    ],
	    "MP": [
	        {
	            "id": "1060482",
	            "name": "Dhanpuri"
	        },
	        {
	            "id": "1066243",
	            "name": "Ujjain"
	        },
	        {
	            "id": "100079",
	            "name": "Umaria"
	        },
	        {
	            "id": "1064263",
	            "name": "Sagar"
	        },
	        {
	            "id": "1060842",
	            "name": "Guna"
	        },
	        {
	            "id": "1062823",
	            "name": "Nagda"
	        },
	        {
	            "id": "1065523",
	            "name": "Sheopur"
	        },
	        {
	            "id": "1065703",
	            "name": "Shivpuri"
	        },
	        {
	            "id": "100078",
	            "name": "Sidhi"
	        },
	        {
	            "id": "1065883",
	            "name": "Singrauli"
	        },
	        {
	            "id": "1066063",
	            "name": "Tikamgarh"
	        },
	        {
	            "id": "1063903",
	            "name": "Ratlam"
	        },
	        {
	            "id": "1064083",
	            "name": "Rewa"
	        },
	        {
	            "id": "1064443",
	            "name": "Sarni"
	        },
	        {
	            "id": "1064623",
	            "name": "Satna"
	        },
	        {
	            "id": "1064803",
	            "name": "Sehore"
	        },
	        {
	            "id": "1065163",
	            "name": "Shahdol"
	        },
	        {
	            "id": "1065343",
	            "name": "Shajapur"
	        },
	        {
	            "id": "1066423",
	            "name": "Vidisha"
	        },
	        {
	            "id": "100077",
	            "name": "Raisen"
	        },
	        {
	            "id": "100069",
	            "name": "Alirajpur"
	        },
	        {
	            "id": "1063723",
	            "name": "Pithampur"
	        },
	        {
	            "id": "483775",
	            "name": "Katni"
	        },
	        {
	            "id": "1060302",
	            "name": "Dewas"
	        },
	        {
	            "id": "1060662",
	            "name": "Dhar"
	        },
	        {
	            "id": "100072",
	            "name": "Dindori"
	        },
	        {
	            "id": "1063363",
	            "name": "Panna"
	        },
	        {
	            "id": "1061743",
	            "name": "Khandwa"
	        },
	        {
	            "id": "1061923",
	            "name": "Khargone"
	        },
	        {
	            "id": "1062643",
	            "name": "Morena"
	        },
	        {
	            "id": "100076",
	            "name": "Neemuch"
	        },
	        {
	            "id": "1061562",
	            "name": "Jaora"
	        },
	        {
	            "id": "100073",
	            "name": "Jhabua"
	        },
	        {
	            "id": "1062103",
	            "name": "Mandla"
	        },
	        {
	            "id": "1062283",
	            "name": "Mandsaur"
	        },
	        {
	            "id": "474003",
	            "name": "Gwalior"
	        },
	        {
	            "id": "1061022",
	            "name": "Harda"
	        },
	        {
	            "id": "1061202",
	            "name": "Hoshangabad"
	        },
	        {
	            "id": "142222",
	            "name": "Indore"
	        },
	        {
	            "id": "1061382",
	            "name": "Itarsi"
	        },
	        {
	            "id": "482004",
	            "name": "Jabalpur"
	        },
	        {
	            "id": "1059402",
	            "name": "Chhatarpur"
	        },
	        {
	            "id": "1059582",
	            "name": "Chhindwara"
	        },
	        {
	            "id": "1059762",
	            "name": "Dabra"
	        },
	        {
	            "id": "1059942",
	            "name": "Damoh"
	        },
	        {
	            "id": "1060122",
	            "name": "Datia"
	        },
	        {
	            "id": "100071",
	            "name": "Barwani"
	        },
	        {
	            "id": "1058682",
	            "name": "Betul"
	        },
	        {
	            "id": "1058862",
	            "name": "Bhind"
	        },
	        {
	            "id": "462001",
	            "name": "Bhopal"
	        },
	        {
	            "id": "1059042",
	            "name": "BinaEtawa"
	        },
	        {
	            "id": "1059222",
	            "name": "Burhanpur"
	        },
	        {
	            "id": "465441",
	            "name": "AgarMalwa"
	        },
	        {
	            "id": "100069",
	            "name": "Alirajpur"
	        },
	        {
	            "id": "100070",
	            "name": "Anuppur"
	        },
	        {
	            "id": "1058322",
	            "name": "Ashoknagar"
	        },
	        {
	            "id": "1058502",
	            "name": "Balaghat"
	        },
	        {
	            "id": "1060302",
	            "name": "Dewas"
	        },
	        {
	            "id": "1063543",
	            "name": "Parasia"
	        },
	        {
	            "id": "1059402",
	            "name": "Chhatarpur"
	        },
	        {
	            "id": "1063543",
	            "name": "Parasia"
	        },
	        {
	            "id": "465441",
	            "name": "AgarMalwa"
	        }
	    ],
	    "MS": [
	        {
	            "id": "1069483",
	            "name": "Buldhana"
	        },
	        {
	            "id": "1067323",
	            "name": "Ambajogai"
	        },
	        {
	            "id": "1067503",
	            "name": "Amravati"
	        },
	        {
	            "id": "1067683",
	            "name": "Anjangaon"
	        },
	        {
	            "id": "1068043",
	            "name": "Ballarpur"
	        },
	        {
	            "id": "1070743",
	            "name": "Hinganghat"
	        },
	        {
	            "id": "1070923",
	            "name": "Hingoli"
	        },
	        {
	            "id": "1071103",
	            "name": "Ichalkaranji"
	        },
	        {
	            "id": "1069663",
	            "name": "Chalisgaon"
	        },
	        {
	            "id": "1069843",
	            "name": "Chandrapur"
	        },
	        {
	            "id": "1070023",
	            "name": "Chopda"
	        },
	        {
	            "id": "1072723",
	            "name": "Latur"
	        },
	        {
	            "id": "1072903",
	            "name": "Lonavla"
	        },
	        {
	            "id": "1068223",
	            "name": "Baramati"
	        },
	        {
	            "id": "1068403",
	            "name": "Barshi"
	        },
	        {
	            "id": "1068583",
	            "name": "Basmath"
	        },
	        {
	            "id": "1068943",
	            "name": "Bhadravati"
	        },
	        {
	            "id": "1069123",
	            "name": "Bhandara"
	        },
	        {
	            "id": "1069303",
	            "name": "Bhusawal"
	        },
	        {
	            "id": "1069483",
	            "name": "Buldhana"
	        },
	        {
	            "id": "1066603",
	            "name": "Achalpur"
	        },
	        {
	            "id": "1066783",
	            "name": "Ahmednagar"
	        },
	        {
	            "id": "444001",
	            "name": "Akola"
	        },
	        {
	            "id": "1066963",
	            "name": "Akot"
	        },
	        {
	            "id": "1067143",
	            "name": "Amalner"
	        },
	        {
	            "id": "1074523",
	            "name": "Palghar"
	        },
	        {
	            "id": "1071283",
	            "name": "Jalgaon"
	        },
	        {
	            "id": "1071463",
	            "name": "Jalna"
	        },
	        {
	            "id": "1068763",
	            "name": "Beed"
	        },
	        {
	            "id": "1073623",
	            "name": "Miraj"
	        },
	        {
	            "id": "416001",
	            "name": "Kolhapur"
	        },
	        {
	            "id": "1072543",
	            "name": "Kopargaon"
	        },
	        {
	            "id": "1073083",
	            "name": "Malegaon"
	        },
	        {
	            "id": "1073263",
	            "name": "Malkapur"
	        },
	        {
	            "id": "1073443",
	            "name": "Manmad"
	        },
	        {
	            "id": "1070383",
	            "name": "Dhule"
	        },
	        {
	            "id": "1071823",
	            "name": "Karad"
	        },
	        {
	            "id": "1074703",
	            "name": "Pandharpur"
	        },
	        {
	            "id": "1074883",
	            "name": "Panvel"
	        },
	        {
	            "id": "1075063",
	            "name": "Parbhani"
	        },
	        {
	            "id": "1075243",
	            "name": "Parli"
	        },
	        {
	            "id": "1072183",
	            "name": "Khamgaon"
	        },
	        {
	            "id": "1072363",
	            "name": "Khopoli"
	        },
	        {
	            "id": "31",
	            "name": "Mumbai"
	        },
	        {
	            "id": "400701",
	            "name": "NaviMumbai"
	        },
	        {
	            "id": "1074343",
	            "name": "Osmanabad"
	        },
	        {
	            "id": "1076503",
	            "name": "Shegaon"
	        },
	        {
	            "id": "1072003",
	            "name": "Karanja"
	        },
	        {
	            "id": "1077403",
	            "name": "VasaiVirar"
	        },
	        {
	            "id": "1077583",
	            "name": "Wani"
	        },
	        {
	            "id": "1077763",
	            "name": "Wardha"
	        },
	        {
	            "id": "1077943",
	            "name": "Washim"
	        },
	        {
	            "id": "1078123",
	            "name": "Yavatmal"
	        },
	        {
	            "id": "33",
	            "name": "Pune"
	        },
	        {
	            "id": "1075783",
	            "name": "Pusad"
	        },
	        {
	            "id": "1075423",
	            "name": "Phaltan"
	        },
	        {
	            "id": "400601",
	            "name": "Thane"
	        },
	        {
	            "id": "421301",
	            "name": "Kalyan"
	        },
	        {
	            "id": "100081",
	            "name": "Sindhudurg"
	        },
	        {
	            "id": "1070563",
	            "name": "Gondia"
	        },
	        {
	            "id": "1070203",
	            "name": "Deolali"
	        },
	        {
	            "id": "400605",
	            "name": "Kalwa"
	        },
	        {
	            "id": "172222",
	            "name": "Nagpur"
	        },
	        {
	            "id": "1076863",
	            "name": "Shrirampur"
	        },
	        {
	            "id": "413001",
	            "name": "Solapur"
	        },
	        {
	            "id": "1075963",
	            "name": "Ratnagiri"
	        },
	        {
	            "id": "1076143",
	            "name": "Sangamner"
	        },
	        {
	            "id": "1076323",
	            "name": "Sangli"
	        },
	        {
	            "id": "415002",
	            "name": "Satara"
	        },
	        {
	            "id": "1073983",
	            "name": "Nandurbar"
	        },
	        {
	            "id": "422001",
	            "name": "Nashik"
	        },
	        {
	            "id": "1077043",
	            "name": "Udgir"
	        },
	        {
	            "id": "431001",
	            "name": "Aurangabad"
	        },
	        {
	            "id": "1077223",
	            "name": "UranIslampur"
	        },
	        {
	            "id": "1077403",
	            "name": "VasaiVirar"
	        },
	        {
	            "id": "421501",
	            "name": "Ambernath"
	        },
	        {
	            "id": "1067863",
	            "name": "Badlapur"
	        },
	        {
	            "id": "1075603",
	            "name": "PimpriChinchwad"
	        },
	        {
	            "id": "1073803",
	            "name": "Nanded"
	        },
	        {
	            "id": "100080",
	            "name": "Gadchiroli"
	        },
	        {
	            "id": "1066783",
	            "name": "Ahmednagar"
	        },
	        {
	            "id": "1074163",
	            "name": "NavgharManikpur"
	        },
	        {
	            "id": "1068043",
	            "name": "Ballarpur"
	        }
	    ],
	    "MA": [
	        {
	            "id": "100086",
	            "name": "Tamenglong"
	        },
	        {
	            "id": "100085",
	            "name": "Senapati"
	        },
	        {
	            "id": "795142",
	            "name": "Ukhrul"
	        },
	        {
	            "id": "100084",
	            "name": "Churachandpur"
	        },
	        {
	            "id": "100083",
	            "name": "Chandel"
	        },
	        {
	            "id": "100087",
	            "name": "Thoubal"
	        },
	        {
	            "id": "1078303",
	            "name": "Imphal"
	        }
	    ],
	    "ME": [
	        {
	            "id": "794001",
	            "name": "WestGaroHills"
	        },
	        {
	            "id": "1078483",
	            "name": "Tura"
	        },
	        {
	            "id": "793001",
	            "name": "Shillong"
	        }
	    ],
	    "MI": [
	        {
	            "id": "100093",
	            "name": "Saiha"
	        },
	        {
	            "id": "100094",
	            "name": "Serchhip"
	        },
	        {
	            "id": "100089",
	            "name": "Kolasib"
	        },
	        {
	            "id": "100092",
	            "name": "Mamit"
	        },
	        {
	            "id": "796321",
	            "name": "Champhai"
	        },
	        {
	            "id": "100091",
	            "name": "Lunglei"
	        },
	        {
	            "id": "796001",
	            "name": "Aizawl"
	        }
	    ],
	    "NA": [
	        {
	            "id": "100096",
	            "name": "Mon"
	        },
	        {
	            "id": "797001",
	            "name": "Kohima"
	        },
	        {
	            "id": "100097",
	            "name": "Phek"
	        },
	        {
	            "id": "1078663",
	            "name": "Dimapur"
	        },
	        {
	            "id": "100099",
	            "name": "Wokha"
	        },
	        {
	            "id": "100100",
	            "name": "Zunheboto"
	        },
	        {
	            "id": "100098",
	            "name": "Tuensang"
	        },
	        {
	            "id": "797101",
	            "name": "Peren"
	        },
	        {
	            "id": "798625",
	            "name": "Longleng"
	        },
	        {
	            "id": "798611",
	            "name": "Kiphire"
	        },
	        {
	            "id": "100095",
	            "name": "Mokokchung"
	        }
	    ],
	    "OR": [
	        {
	            "id": "100116",
	            "name": "Nabarangpur"
	        },
	        {
	            "id": "1078843",
	            "name": "Balangir"
	        },
	        {
	            "id": "1080283",
	            "name": "Brajarajnagar"
	        },
	        {
	            "id": "100232",
	            "name": "Paralakhemundi"
	        },
	        {
	            "id": "100106",
	            "name": "Ganjam"
	        },
	        {
	            "id": "1079023",
	            "name": "Balasore"
	        },
	        {
	            "id": "100109",
	            "name": "Kalahandi"
	        },
	        {
	            "id": "100102",
	            "name": "Boudh"
	        },
	        {
	            "id": "761200",
	            "name": "Gajapati"
	        },
	        {
	            "id": "100110",
	            "name": "Kandhamal"
	        },
	        {
	            "id": "100115",
	            "name": "Mayurbhanj"
	        },
	        {
	            "id": "100112",
	            "name": "Koraput"
	        },
	        {
	            "id": "100117",
	            "name": "Nayagarh"
	        },
	        {
	            "id": "1081363",
	            "name": "Paradip"
	        },
	        {
	            "id": "100113",
	            "name": "Khordha"
	        },
	        {
	            "id": "1081903",
	            "name": "Rourkela"
	        },
	        {
	            "id": "1080463",
	            "name": "Dhenkanal"
	        },
	        {
	            "id": "100111",
	            "name": "Kendrapara"
	        },
	        {
	            "id": "1081183",
	            "name": "Kendujhar"
	        },
	        {
	            "id": "1081543",
	            "name": "Puri"
	        },
	        {
	            "id": "1081723",
	            "name": "Rayagada"
	        },
	        {
	            "id": "1082083",
	            "name": "Sambalpur"
	        },
	        {
	            "id": "1082263",
	            "name": "Sunabeda"
	        },
	        {
	            "id": "100119",
	            "name": "Sundargarh"
	        },
	        {
	            "id": "1078843",
	            "name": "Balangir"
	        },
	        {
	            "id": "1079203",
	            "name": "Barbil"
	        },
	        {
	            "id": "1079383",
	            "name": "Bargarh"
	        },
	        {
	            "id": "1079563",
	            "name": "Baripada"
	        },
	        {
	            "id": "1079743",
	            "name": "Bhadrak"
	        },
	        {
	            "id": "1079923",
	            "name": "Bhawanipatna"
	        },
	        {
	            "id": "751001",
	            "name": "Bhubaneswar"
	        },
	        {
	            "id": "751001",
	            "name": "Bhubaneswar"
	        },
	        {
	            "id": "1080103",
	            "name": "Brahmapur"
	        },
	        {
	            "id": "1080283",
	            "name": "Brajarajnagar"
	        },
	        {
	            "id": "100225",
	            "name": "Chatrapur"
	        },
	        {
	            "id": "753001",
	            "name": "Cuttack"
	        },
	        {
	            "id": "100114",
	            "name": "Malkangiri"
	        },
	        {
	            "id": "100107",
	            "name": "Jagatsinghpur"
	        },
	        {
	            "id": "1080643",
	            "name": "Jatani"
	        },
	        {
	            "id": "1080823",
	            "name": "Jeypore"
	        },
	        {
	            "id": "1081003",
	            "name": "Jharsuguda"
	        },
	        {
	            "id": "100101",
	            "name": "Angul"
	        },
	        {
	            "id": "766104",
	            "name": "Nuapada"
	        },
	        {
	            "id": "100105",
	            "name": "Deogarh"
	        },
	        {
	            "id": "1081003",
	            "name": "Jharsuguda"
	        }
	    ],
	    "PO": [
	        {
	            "id": "605001",
	            "name": "Pondicherry"
	        },
	        {
	            "id": "673310",
	            "name": "Mahe"
	        },
	        {
	            "id": "1082443",
	            "name": "Karaikal"
	        }
	    ],
	    "PJ": [
	        {
	            "id": "144001",
	            "name": "Jalandhar"
	        },
	        {
	            "id": "100248",
	            "name": "Nakodar"
	        },
	        {
	            "id": "100248",
	            "name": "Nakodar"
	        },
	        {
	            "id": "1087123",
	            "name": "Sangrur"
	        },
	        {
	            "id": "1087663",
	            "name": "Sunam"
	        },
	        {
	            "id": "1087843",
	            "name": "TarnTaranSahib"
	        },
	        {
	            "id": "1083523",
	            "name": "Faridkot"
	        },
	        {
	            "id": "1083703",
	            "name": "Fazilka"
	        },
	        {
	            "id": "1083883",
	            "name": "Firozpur"
	        },
	        {
	            "id": "1084063",
	            "name": "FirozpurCantonment"
	        },
	        {
	            "id": "1085683",
	            "name": "MandiGobindgarh"
	        },
	        {
	            "id": "1086223",
	            "name": "Nabha"
	        },
	        {
	            "id": "100248",
	            "name": "Nakodar"
	        },
	        {
	            "id": "1086043",
	            "name": "Moga"
	        },
	        {
	            "id": "1087483",
	            "name": "SriMuktsarSahib"
	        },
	        {
	            "id": "144514",
	            "name": "Nawanshahr"
	        },
	        {
	            "id": "1086403",
	            "name": "Pathankot"
	        },
	        {
	            "id": "1086583",
	            "name": "Patiala"
	        },
	        {
	            "id": "1084963",
	            "name": "Khanna"
	        },
	        {
	            "id": "1086763",
	            "name": "Phagwara"
	        },
	        {
	            "id": "100120",
	            "name": "FatehgarhSahib"
	        },
	        {
	            "id": "1084783",
	            "name": "Kapurthala"
	        },
	        {
	            "id": "1085143",
	            "name": "Kotkapura"
	        },
	        {
	            "id": "160104",
	            "name": "Zirakpur"
	        },
	        {
	            "id": "160104",
	            "name": "Zirakpur"
	        },
	        {
	            "id": "1086943",
	            "name": "Rajpura"
	        },
	        {
	            "id": "100121",
	            "name": "Rupnagar"
	        },
	        {
	            "id": "1082803",
	            "name": "Abohar"
	        },
	        {
	            "id": "143104",
	            "name": "Amritsar"
	        },
	        {
	            "id": "1082983",
	            "name": "Barnala"
	        },
	        {
	            "id": "1083163",
	            "name": "Batala"
	        },
	        {
	            "id": "1083343",
	            "name": "Bathinda"
	        },
	        {
	            "id": "141001",
	            "name": "Ludhiana"
	        },
	        {
	            "id": "1085323",
	            "name": "Malerkotla"
	        },
	        {
	            "id": "1085503",
	            "name": "Malout"
	        },
	        {
	            "id": "1085863",
	            "name": "Mansa"
	        },
	        {
	            "id": "1084243",
	            "name": "Gurdaspur"
	        },
	        {
	            "id": "1084423",
	            "name": "Hoshiarpur"
	        },
	        {
	            "id": "1084603",
	            "name": "Jagraon"
	        },
	        {
	            "id": "144001",
	            "name": "Jalandhar"
	        }
	    ],
	    "RJ": [
	        {
	            "id": "301019",
	            "name": "Bhiwadi"
	        },
	        {
	            "id": "1088203",
	            "name": "Balotra"
	        },
	        {
	            "id": "1090363",
	            "name": "Dausa"
	        },
	        {
	            "id": "305001",
	            "name": "Ajmer"
	        },
	        {
	            "id": "1088023",
	            "name": "Alwar"
	        },
	        {
	            "id": "1088203",
	            "name": "Balotra"
	        },
	        {
	            "id": "1088383",
	            "name": "Banswara"
	        },
	        {
	            "id": "1088563",
	            "name": "Baran"
	        },
	        {
	            "id": "1088743",
	            "name": "Bari"
	        },
	        {
	            "id": "1088923",
	            "name": "Barmer"
	        },
	        {
	            "id": "1089103",
	            "name": "Beawar"
	        },
	        {
	            "id": "1089283",
	            "name": "Bharatpur"
	        },
	        {
	            "id": "1089463",
	            "name": "Bhilwara"
	        },
	        {
	            "id": "301019",
	            "name": "Bhiwadi"
	        },
	        {
	            "id": "334001",
	            "name": "Bikaner"
	        },
	        {
	            "id": "1089643",
	            "name": "Bundi"
	        },
	        {
	            "id": "1089823",
	            "name": "Chittorgarh"
	        },
	        {
	            "id": "1090003",
	            "name": "Chomu"
	        },
	        {
	            "id": "1090183",
	            "name": "Churu"
	        },
	        {
	            "id": "1090363",
	            "name": "Dausa"
	        },
	        {
	            "id": "1092523",
	            "name": "Ladnun"
	        },
	        {
	            "id": "1092703",
	            "name": "Makrana"
	        },
	        {
	            "id": "1091083",
	            "name": "Hanumangarh"
	        },
	        {
	            "id": "1091263",
	            "name": "Hindaun"
	        },
	        {
	            "id": "152222",
	            "name": "Jaipur"
	        },
	        {
	            "id": "1091443",
	            "name": "Jaisalmer"
	        },
	        {
	            "id": "100123",
	            "name": "Jalore"
	        },
	        {
	            "id": "100124",
	            "name": "Jhalawar"
	        },
	        {
	            "id": "1090543",
	            "name": "Dholpur"
	        },
	        {
	            "id": "100123",
	            "name": "Jalore"
	        },
	        {
	            "id": "1092163",
	            "name": "Kota"
	        },
	        {
	            "id": "1092343",
	            "name": "Kuchaman"
	        },
	        {
	            "id": "1093063",
	            "name": "Nawalgarh"
	        },
	        {
	            "id": "1093243",
	            "name": "Nimbahera"
	        },
	        {
	            "id": "1093423",
	            "name": "Pali"
	        },
	        {
	            "id": "1091623",
	            "name": "Jhunjhunu"
	        },
	        {
	            "id": "342001",
	            "name": "Jodhpur"
	        },
	        {
	            "id": "1091983",
	            "name": "Kishangarh"
	        },
	        {
	            "id": "1093603",
	            "name": "Rajgarh"
	        },
	        {
	            "id": "1146938",
	            "name": "Neemrana"
	        },
	        {
	            "id": "100226",
	            "name": "Didwana"
	        },
	        {
	            "id": "1091803",
	            "name": "Karauli"
	        },
	        {
	            "id": "305002",
	            "name": "Pushkar"
	        },
	        {
	            "id": "1093783",
	            "name": "Rajsamand"
	        },
	        {
	            "id": "1093963",
	            "name": "Ratangarh"
	        },
	        {
	            "id": "1094143",
	            "name": "Sardarshahar"
	        },
	        {
	            "id": "1094323",
	            "name": "SawaiMadhopur"
	        },
	        {
	            "id": "1094503",
	            "name": "Sikar"
	        },
	        {
	            "id": "100125",
	            "name": "Sirohi"
	        },
	        {
	            "id": "1094683",
	            "name": "Sujangarh"
	        },
	        {
	            "id": "1094863",
	            "name": "Suratgarh"
	        },
	        {
	            "id": "1095043",
	            "name": "Tonk"
	        },
	        {
	            "id": "313001",
	            "name": "Udaipur"
	        },
	        {
	            "id": "100122",
	            "name": "Dungarpur"
	        },
	        {
	            "id": "1090903",
	            "name": "GangapurCity"
	        },
	        {
	            "id": "1090723",
	            "name": "Ganganagar"
	        },
	        {
	            "id": "1092883",
	            "name": "Nagaur"
	        },
	        {
	            "id": "1091443",
	            "name": "Jaisalmer"
	        },
	        {
	            "id": "100124",
	            "name": "Jhalawar"
	        }
	    ],
	    "SKM": [
	        {
	            "id": "737101",
	            "name": "EastSikkim"
	        },
	        {
	            "id": "1095223",
	            "name": "Gangtok"
	        },
	        {
	            "id": "737116",
	            "name": "NorthSikkim"
	        },
	        {
	            "id": "737126",
	            "name": "SouthSikkim"
	        }
	    ],
	    "TN": [
	        {
	            "id": "1098103",
	            "name": "Dharapuram"
	        },
	        {
	            "id": "1098643",
	            "name": "Erode"
	        },
	        {
	            "id": "1095403",
	            "name": "Aarani"
	        },
	        {
	            "id": "1099903",
	            "name": "Karaikudi"
	        },
	        {
	            "id": "1103683",
	            "name": "Pudukkottai"
	        },
	        {
	            "id": "1107463",
	            "name": "Vaniyambadi"
	        },
	        {
	            "id": "1107463",
	            "name": "Vaniyambadi"
	        },
	        {
	            "id": "1096663",
	            "name": "Avaniapuram"
	        },
	        {
	            "id": "1095943",
	            "name": "Arakkonam"
	        },
	        {
	            "id": "1095403",
	            "name": "Aarani"
	        },
	        {
	            "id": "1107283",
	            "name": "Valparai"
	        },
	        {
	            "id": "1107463",
	            "name": "Vaniyambadi"
	        },
	        {
	            "id": "632001",
	            "name": "Vellore"
	        },
	        {
	            "id": "1100263",
	            "name": "Komarapalayam"
	        },
	        {
	            "id": "1102783",
	            "name": "Pallavaram"
	        },
	        {
	            "id": "1105303",
	            "name": "TheniAllinagaram"
	        },
	        {
	            "id": "1098643",
	            "name": "Erode"
	        },
	        {
	            "id": "1098823",
	            "name": "Gobichettipalayam"
	        },
	        {
	            "id": "1099003",
	            "name": "Gudiyatham"
	        },
	        {
	            "id": "1105663",
	            "name": "Thoothukudi"
	        },
	        {
	            "id": "1101703",
	            "name": "Nagapattinam"
	        },
	        {
	            "id": "1101883",
	            "name": "Nagercoil"
	        },
	        {
	            "id": "1099363",
	            "name": "Kadayanallur"
	        },
	        {
	            "id": "1102063",
	            "name": "Namakkal"
	        },
	        {
	            "id": "1107103",
	            "name": "Udumalaipettai"
	        },
	        {
	            "id": "1105483",
	            "name": "Thiruvarur"
	        },
	        {
	            "id": "1105843",
	            "name": "Tindivanam"
	        },
	        {
	            "id": "1106023",
	            "name": "Tiruchendur"
	        },
	        {
	            "id": "1106203",
	            "name": "Tiruchengode"
	        },
	        {
	            "id": "620015",
	            "name": "Trichy"
	        },
	        {
	            "id": "1106383",
	            "name": "Tirunelveli"
	        },
	        {
	            "id": "1106563",
	            "name": "Tirupathur"
	        },
	        {
	            "id": "1106923",
	            "name": "Tiruvannamalai"
	        },
	        {
	            "id": "100128",
	            "name": "Sivaganga"
	        },
	        {
	            "id": "1104583",
	            "name": "Sivakasi"
	        },
	        {
	            "id": "1104763",
	            "name": "Srivilliputhur"
	        },
	        {
	            "id": "1104943",
	            "name": "Tenkasi"
	        },
	        {
	            "id": "1105123",
	            "name": "Thanjavur"
	        },
	        {
	            "id": "1107643",
	            "name": "Viluppuram"
	        },
	        {
	            "id": "1107823",
	            "name": "Virudhachalam"
	        },
	        {
	            "id": "1108003",
	            "name": "Virudhunagar"
	        },
	        {
	            "id": "1104043",
	            "name": "Rajapalayam"
	        },
	        {
	            "id": "1104223",
	            "name": "Ramanathapuram"
	        },
	        {
	            "id": "100233",
	            "name": "Rasipuram"
	        },
	        {
	            "id": "636001",
	            "name": "Salem"
	        },
	        {
	            "id": "1104403",
	            "name": "Sankarankoil"
	        },
	        {
	            "id": "1103683",
	            "name": "Pudukkottai"
	        },
	        {
	            "id": "1103863",
	            "name": "Puliyankudi"
	        },
	        {
	            "id": "643001",
	            "name": "Nilgiris"
	        },
	        {
	            "id": "100207",
	            "name": "Devakottai"
	        },
	        {
	            "id": "1097923",
	            "name": "Devarshola"
	        },
	        {
	            "id": "1098103",
	            "name": "Dharapuram"
	        },
	        {
	            "id": "1098283",
	            "name": "Dharmapuri"
	        },
	        {
	            "id": "1098463",
	            "name": "Dindigul"
	        },
	        {
	            "id": "629161",
	            "name": "Kanyakumari"
	        },
	        {
	            "id": "1100083",
	            "name": "Karur"
	        },
	        {
	            "id": "1099543",
	            "name": "Kambam"
	        },
	        {
	            "id": "1099723",
	            "name": "Kanchipuram"
	        },
	        {
	            "id": "1103323",
	            "name": "Pattukkottai"
	        },
	        {
	            "id": "100127",
	            "name": "Perambalur"
	        },
	        {
	            "id": "1103503",
	            "name": "Pollachi"
	        },
	        {
	            "id": "1102243",
	            "name": "Neyveli"
	        },
	        {
	            "id": "1102603",
	            "name": "Palani"
	        },
	        {
	            "id": "1098823",
	            "name": "Gobichettipalayam"
	        },
	        {
	            "id": "1102963",
	            "name": "Panruti"
	        },
	        {
	            "id": "1103143",
	            "name": "Paramakudi"
	        },
	        {
	            "id": "1101703",
	            "name": "Nagapattinam"
	        },
	        {
	            "id": "1099363",
	            "name": "Kadayanallur"
	        },
	        {
	            "id": "1100443",
	            "name": "Kovilpatti"
	        },
	        {
	            "id": "1100623",
	            "name": "Krishnagiri"
	        },
	        {
	            "id": "1100803",
	            "name": "Kumbakonam"
	        },
	        {
	            "id": "1101163",
	            "name": "Mayiladuthurai"
	        },
	        {
	            "id": "1101343",
	            "name": "Mettupalayam"
	        },
	        {
	            "id": "1101523",
	            "name": "Mettur"
	        },
	        {
	            "id": "625001",
	            "name": "Madurai"
	        },
	        {
	            "id": "1100983",
	            "name": "Mannargudi"
	        },
	        {
	            "id": "1099183",
	            "name": "Hosur"
	        },
	        {
	            "id": "1107643",
	            "name": "Viluppuram"
	        },
	        {
	            "id": "1102423",
	            "name": "Ooty"
	        },
	        {
	            "id": "1096843",
	            "name": "Bhavani"
	        },
	        {
	            "id": "1097023",
	            "name": "Bodinayakkanur"
	        },
	        {
	            "id": "1097203",
	            "name": "Chengalpattu"
	        },
	        {
	            "id": "25",
	            "name": "Chennai"
	        },
	        {
	            "id": "1098823",
	            "name": "Gobichettipalayam"
	        },
	        {
	            "id": "1097383",
	            "name": "Chidambaram"
	        },
	        {
	            "id": "26",
	            "name": "Coimbatore"
	        },
	        {
	            "id": "1097563",
	            "name": "Coonoor"
	        },
	        {
	            "id": "1097743",
	            "name": "Cuddalore"
	        },
	        {
	            "id": "1095583",
	            "name": "Ambasamudram"
	        },
	        {
	            "id": "1095763",
	            "name": "Ambur"
	        },
	        {
	            "id": "1095403",
	            "name": "Aarani"
	        },
	        {
	            "id": "1096123",
	            "name": "Arcot"
	        },
	        {
	            "id": "100126",
	            "name": "Ariyalur"
	        },
	        {
	            "id": "1096303",
	            "name": "Aruppukkottai"
	        },
	        {
	            "id": "1096483",
	            "name": "Attur"
	        },
	        {
	            "id": "100214",
	            "name": "Pandalur"
	        }
	    ],
	    "TL": [
	        {
	            "id": "507101",
	            "name": "BhadradriKothagudem"
	        },
	        {
	            "id": "1001621",
	            "name": "Bodhan"
	        },
	        {
	            "id": "1000001",
	            "name": "Adilabad"
	        },
	        {
	            "id": "504293",
	            "name": "Asifabad"
	        },
	        {
	            "id": "506101",
	            "name": "Mahabubabad"
	        },
	        {
	            "id": "509125",
	            "name": "JogulambaGadwal"
	        },
	        {
	            "id": "507101",
	            "name": "BhadradriKothagudem"
	        },
	        {
	            "id": "505172",
	            "name": "Peddapalli"
	        },
	        {
	            "id": "501101",
	            "name": "Vikarabad"
	        },
	        {
	            "id": "1003241",
	            "name": "Gadwal"
	        },
	        {
	            "id": "509209",
	            "name": "Nagarkurnool"
	        },
	        {
	            "id": "1007921",
	            "name": "Nalgonda"
	        },
	        {
	            "id": "1012421",
	            "name": "Siddipet"
	        },
	        {
	            "id": "505301",
	            "name": "RajannaSircilla"
	        },
	        {
	            "id": "1013141",
	            "name": "Suryapet"
	        },
	        {
	            "id": "1013681",
	            "name": "Tandur"
	        },
	        {
	            "id": "1015121",
	            "name": "Wanaparthi"
	        },
	        {
	            "id": "506002",
	            "name": "Warangal"
	        },
	        {
	            "id": "1010981",
	            "name": "Ramagundam"
	        },
	        {
	            "id": "1011701",
	            "name": "Sangareddy"
	        },
	        {
	            "id": "1012061",
	            "name": "Secunderabad"
	        },
	        {
	            "id": "1005401",
	            "name": "Karimnagar"
	        },
	        {
	            "id": "503111",
	            "name": "Kamareddy"
	        },
	        {
	            "id": "1008641",
	            "name": "Nirmal"
	        },
	        {
	            "id": "1008821",
	            "name": "Nizamabad"
	        },
	        {
	            "id": "1009541",
	            "name": "Palwancha"
	        },
	        {
	            "id": "1004681",
	            "name": "Kagaznagar"
	        },
	        {
	            "id": "1005941",
	            "name": "Koratla"
	        },
	        {
	            "id": "507101",
	            "name": "BhadradriKothagudem"
	        },
	        {
	            "id": "100129",
	            "name": "Medak"
	        },
	        {
	            "id": "1007741",
	            "name": "Miryalguda"
	        },
	        {
	            "id": "1006841",
	            "name": "Mahbubnagar"
	        },
	        {
	            "id": "1007021",
	            "name": "Mancherial"
	        },
	        {
	            "id": "1007201",
	            "name": "Mandamarri"
	        },
	        {
	            "id": "28",
	            "name": "Hyderabad"
	        },
	        {
	            "id": "1004321",
	            "name": "Jagtial"
	        },
	        {
	            "id": "506167",
	            "name": "Jangaon"
	        },
	        {
	            "id": "100130",
	            "name": "RangaReddy"
	        },
	        {
	            "id": "1001081",
	            "name": "Bellampalle"
	        },
	        {
	            "id": "1000001",
	            "name": "Adilabad"
	        },
	        {
	            "id": "507101",
	            "name": "BhadradriKothagudem"
	        }
	    ],
	    "TR": [
	        {
	            "id": "1108183",
	            "name": "Agartala"
	        },
	        {
	            "id": "799201",
	            "name": "Khowai"
	        },
	        {
	            "id": "799101",
	            "name": "Gomati"
	        },
	        {
	            "id": "799290",
	            "name": "Unakoti"
	        },
	        {
	            "id": "100134",
	            "name": "WestTripura"
	        },
	        {
	            "id": "100132",
	            "name": "NorthTripura"
	        },
	        {
	            "id": "100133",
	            "name": "SouthTripura"
	        },
	        {
	            "id": "100131",
	            "name": "Dhalai"
	        },
	        {
	            "id": "799201",
	            "name": "Khowai"
	        },
	        {
	            "id": "799102",
	            "name": "Sipahijala"
	        },
	        {
	            "id": "1108183",
	            "name": "Agartala"
	        }
	    ],
	    "UP": [
	        {
	            "id": "1121503",
	            "name": "Raebareli"
	        },
	        {
	            "id": "1124923",
	            "name": "Unnao"
	        },
	        {
	            "id": "1121683",
	            "name": "Rampur"
	        },
	        {
	            "id": "1122223",
	            "name": "Saharanpur"
	        },
	        {
	            "id": "1122583",
	            "name": "Sambhal"
	        },
	        {
	            "id": "1122943",
	            "name": "Shahjahanpur"
	        },
	        {
	            "id": "1125103",
	            "name": "Vrindavan"
	        },
	        {
	            "id": "1109983",
	            "name": "Baraut"
	        },
	        {
	            "id": "1112503",
	            "name": "Deoria"
	        },
	        {
	            "id": "1118623",
	            "name": "Mau"
	        },
	        {
	            "id": "100139",
	            "name": "Chitrakoot"
	        },
	        {
	            "id": "1117543",
	            "name": "Laharpur"
	        },
	        {
	            "id": "225402",
	            "name": "Barabanki"
	        },
	        {
	            "id": "1118803",
	            "name": "Mauranipur"
	        },
	        {
	            "id": "100136",
	            "name": "Amethi"
	        },
	        {
	            "id": "281001",
	            "name": "Mathura"
	        },
	        {
	            "id": "1111243",
	            "name": "Budaun"
	        },
	        {
	            "id": "221002",
	            "name": "Varanasi"
	        },
	        {
	            "id": "1113403",
	            "name": "Farrukhabad"
	        },
	        {
	            "id": "100146",
	            "name": "SantKabirNagar"
	        },
	        {
	            "id": "100135",
	            "name": "AmbedkarNagar"
	        },
	        {
	            "id": "1113583",
	            "name": "Fatehpur"
	        },
	        {
	            "id": "1119163",
	            "name": "Mirzapur"
	        },
	        {
	            "id": "100145",
	            "name": "Pratapgarh"
	        },
	        {
	            "id": "100149",
	            "name": "Sonbhadra"
	        },
	        {
	            "id": "100141",
	            "name": "Kaushambi"
	        },
	        {
	            "id": "100148",
	            "name": "Siddharthnagar"
	        },
	        {
	            "id": "100147",
	            "name": "Shrawasti"
	        },
	        {
	            "id": "1112683",
	            "name": "Etah"
	        },
	        {
	            "id": "1112863",
	            "name": "Etawah"
	        },
	        {
	            "id": "1113043",
	            "name": "Faizabad"
	        },
	        {
	            "id": "1113223",
	            "name": "Faridpur"
	        },
	        {
	            "id": "1113763",
	            "name": "Firozabad"
	        },
	        {
	            "id": "1113943",
	            "name": "Gangaghat"
	        },
	        {
	            "id": "1114123",
	            "name": "Gangoh"
	        },
	        {
	            "id": "201002",
	            "name": "Ghaziabad"
	        },
	        {
	            "id": "1114303",
	            "name": "Ghazipur"
	        },
	        {
	            "id": "1114483",
	            "name": "GolaGokarannath"
	        },
	        {
	            "id": "1114663",
	            "name": "Gonda"
	        },
	        {
	            "id": "1114843",
	            "name": "Gorakhpur"
	        },
	        {
	            "id": "201310",
	            "name": "GreaterNoida"
	        },
	        {
	            "id": "1120063",
	            "name": "Muzaffarnagar"
	        },
	        {
	            "id": "1118803",
	            "name": "Mauranipur"
	        },
	        {
	            "id": "246746",
	            "name": "Seohara"
	        },
	        {
	            "id": "1112503",
	            "name": "Deoria"
	        },
	        {
	            "id": "246761",
	            "name": "Dhampur"
	        },
	        {
	            "id": "1116463",
	            "name": "Kannauj"
	        },
	        {
	            "id": "208001",
	            "name": "Kanpur"
	        },
	        {
	            "id": "1116643",
	            "name": "Kasganj"
	        },
	        {
	            "id": "1116823",
	            "name": "Khatauli"
	        },
	        {
	            "id": "100142",
	            "name": "LakhimpurKheri"
	        },
	        {
	            "id": "1117003",
	            "name": "Khurja"
	        },
	        {
	            "id": "1117183",
	            "name": "Kiratpur"
	        },
	        {
	            "id": "1112323",
	            "name": "Deoband"
	        },
	        {
	            "id": "1119343",
	            "name": "Modinagar"
	        },
	        {
	            "id": "244302",
	            "name": "Moradabad"
	        },
	        {
	            "id": "1119523",
	            "name": "Mubarakpur"
	        },
	        {
	            "id": "1119703",
	            "name": "Mughalsarai"
	        },
	        {
	            "id": "1119883",
	            "name": "Muradnagar"
	        },
	        {
	            "id": "201301",
	            "name": "Noida"
	        },
	        {
	            "id": "1116283",
	            "name": "Kairana"
	        },
	        {
	            "id": "1115743",
	            "name": "Jahangirabad"
	        },
	        {
	            "id": "222136",
	            "name": "Jalalpur"
	        },
	        {
	            "id": "100198",
	            "name": "Jalaun"
	        },
	        {
	            "id": "1115923",
	            "name": "Jaunpur"
	        },
	        {
	            "id": "1116103",
	            "name": "Jhansi"
	        },
	        {
	            "id": "1117363",
	            "name": "Konch"
	        },
	        {
	            "id": "100143",
	            "name": "Kushinagar"
	        },
	        {
	            "id": "1118983",
	            "name": "Mawana"
	        },
	        {
	            "id": "250002",
	            "name": "Meerut"
	        },
	        {
	            "id": "100144",
	            "name": "Maharajganj"
	        },
	        {
	            "id": "1118263",
	            "name": "Mahoba"
	        },
	        {
	            "id": "1118443",
	            "name": "Mainpuri"
	        },
	        {
	            "id": "281001",
	            "name": "Mathura"
	        },
	        {
	            "id": "1118803",
	            "name": "Mauranipur"
	        },
	        {
	            "id": "1115023",
	            "name": "Hapur"
	        },
	        {
	            "id": "1115203",
	            "name": "Hardoi"
	        },
	        {
	            "id": "1115383",
	            "name": "Hasanpur"
	        },
	        {
	            "id": "1115563",
	            "name": "Hathras"
	        },
	        {
	            "id": "1111243",
	            "name": "Budaun"
	        },
	        {
	            "id": "1111423",
	            "name": "Bulandshahr"
	        },
	        {
	            "id": "100138",
	            "name": "Chandauli"
	        },
	        {
	            "id": "1111603",
	            "name": "Chandausi"
	        },
	        {
	            "id": "1111783",
	            "name": "Chandpur"
	        },
	        {
	            "id": "1111963",
	            "name": "Chhibramau"
	        },
	        {
	            "id": "1112143",
	            "name": "Dadri"
	        },
	        {
	            "id": "221304",
	            "name": "SantRavidasNagar"
	        },
	        {
	            "id": "1117543",
	            "name": "Laharpur"
	        },
	        {
	            "id": "1117723",
	            "name": "Lakhimpur"
	        },
	        {
	            "id": "1117903",
	            "name": "Lalitpur"
	        },
	        {
	            "id": "1118083",
	            "name": "Loni"
	        },
	        {
	            "id": "162222",
	            "name": "Lucknow"
	        },
	        {
	            "id": "1109443",
	            "name": "Ballia"
	        },
	        {
	            "id": "1109623",
	            "name": "Balrampur"
	        },
	        {
	            "id": "1109803",
	            "name": "Banda"
	        },
	        {
	            "id": "100170",
	            "name": "Bansi"
	        },
	        {
	            "id": "225402",
	            "name": "Barabanki"
	        },
	        {
	            "id": "1109983",
	            "name": "Baraut"
	        },
	        {
	            "id": "243001",
	            "name": "Bareilly"
	        },
	        {
	            "id": "1110163",
	            "name": "Basti"
	        },
	        {
	            "id": "1110343",
	            "name": "BehtaHajipur"
	        },
	        {
	            "id": "1110523",
	            "name": "BelaPratapgarh"
	        },
	        {
	            "id": "1110703",
	            "name": "Bhadohi"
	        },
	        {
	            "id": "1110883",
	            "name": "Bijnor"
	        },
	        {
	            "id": "1111063",
	            "name": "Bisalpur"
	        },
	        {
	            "id": "282002",
	            "name": "Agra"
	        },
	        {
	            "id": "100167",
	            "name": "Akbarpur"
	        },
	        {
	            "id": "1108363",
	            "name": "Aligarh"
	        },
	        {
	            "id": "211001",
	            "name": "Allahabad"
	        },
	        {
	            "id": "100136",
	            "name": "Amethi"
	        },
	        {
	            "id": "1108543",
	            "name": "Amroha"
	        },
	        {
	            "id": "1108723",
	            "name": "Auraiya"
	        },
	        {
	            "id": "1108903",
	            "name": "Azamgarh"
	        },
	        {
	            "id": "1109083",
	            "name": "Baheri"
	        },
	        {
	            "id": "1109263",
	            "name": "Bahraich"
	        }
	    ],
	    "UTT": [
	        {
	            "id": "100152",
	            "name": "Champawat"
	        },
	        {
	            "id": "100154",
	            "name": "Pithoragarh"
	        },
	        {
	            "id": "100152",
	            "name": "Champawat"
	        },
	        {
	            "id": "263601",
	            "name": "Almora"
	        },
	        {
	            "id": "100150",
	            "name": "Bageshwar"
	        },
	        {
	            "id": "100158",
	            "name": "Uttarkashi"
	        },
	        {
	            "id": "100151",
	            "name": "Chamoli"
	        },
	        {
	            "id": "100153",
	            "name": "PauriGarhwal"
	        },
	        {
	            "id": "100157",
	            "name": "UdhamSinghNagar"
	        },
	        {
	            "id": "248179",
	            "name": "Mussoorie"
	        },
	        {
	            "id": "100156",
	            "name": "TehriGarhwal"
	        },
	        {
	            "id": "1125823",
	            "name": "Rishikesh"
	        },
	        {
	            "id": "1126003",
	            "name": "Roorkee"
	        },
	        {
	            "id": "100155",
	            "name": "Rudraprayag"
	        },
	        {
	            "id": "1126183",
	            "name": "Rudrapur"
	        },
	        {
	            "id": "1125643",
	            "name": "Kashipur"
	        },
	        {
	            "id": "100153",
	            "name": "PauriGarhwal"
	        },
	        {
	            "id": "100154",
	            "name": "Pithoragarh"
	        },
	        {
	            "id": "248003",
	            "name": "Dehradun"
	        },
	        {
	            "id": "100230",
	            "name": "Kotdwara"
	        },
	        {
	            "id": "1125283",
	            "name": "Haldwani"
	        },
	        {
	            "id": "1125463",
	            "name": "Hardwar"
	        }
	    ],
	    "WB": [
	        {
	            "id": "1138243",
	            "name": "Kanchrapara"
	        },
	        {
	            "id": "1127983",
	            "name": "Bansberia"
	        },
	        {
	            "id": "1136443",
	            "name": "Jamuria"
	        },
	        {
	            "id": "100163",
	            "name": "DakshinDinajpur"
	        },
	        {
	            "id": "1131403",
	            "name": "Chandrokona"
	        },
	        {
	            "id": "731101",
	            "name": "Birbhum"
	        },
	        {
	            "id": "1134643",
	            "name": "Gobardanga"
	        },
	        {
	            "id": "1138963",
	            "name": "Khardaha"
	        },
	        {
	            "id": "1131223",
	            "name": "Chandannagar"
	        },
	        {
	            "id": "741101",
	            "name": "Nadia"
	        },
	        {
	            "id": "100159",
	            "name": "Malda"
	        },
	        {
	            "id": "1141483",
	            "name": "Murshidabad"
	        },
	        {
	            "id": "1128343",
	            "name": "Barasat"
	        },
	        {
	            "id": "100162",
	            "name": "South24Parganas"
	        },
	        {
	            "id": "731101",
	            "name": "Birbhum"
	        },
	        {
	            "id": "1132663",
	            "name": "Dhulian"
	        },
	        {
	            "id": "1132843",
	            "name": "Dhupguri"
	        },
	        {
	            "id": "1133023",
	            "name": "DiamondHarbour"
	        },
	        {
	            "id": "1138603",
	            "name": "Katwa"
	        },
	        {
	            "id": "1144903",
	            "name": "Siliguri"
	        },
	        {
	            "id": "1145263",
	            "name": "Suri"
	        },
	        {
	            "id": "1133203",
	            "name": "Dubrajpur"
	        },
	        {
	            "id": "1133563",
	            "name": "Durgapur"
	        },
	        {
	            "id": "1133743",
	            "name": "Egra"
	        },
	        {
	            "id": "1134103",
	            "name": "Gangarampur"
	        },
	        {
	            "id": "1134463",
	            "name": "Ghatal"
	        },
	        {
	            "id": "1139863",
	            "name": "Kurseong"
	        },
	        {
	            "id": "100200",
	            "name": "Medinipur"
	        },
	        {
	            "id": "1140763",
	            "name": "Mekliganj"
	        },
	        {
	            "id": "1140943",
	            "name": "Memari"
	        },
	        {
	            "id": "1141303",
	            "name": "Mirik"
	        },
	        {
	            "id": "1137163",
	            "name": "JiaganjAzimganj"
	        },
	        {
	            "id": "1137343",
	            "name": "Kaliaganj"
	        },
	        {
	            "id": "1137523",
	            "name": "Kalimpong"
	        },
	        {
	            "id": "1137703",
	            "name": "Kalna"
	        },
	        {
	            "id": "1138423",
	            "name": "Kandi"
	        },
	        {
	            "id": "1138783",
	            "name": "Kharar"
	        },
	        {
	            "id": "1139323",
	            "name": "Konnagar"
	        },
	        {
	            "id": "1138243",
	            "name": "Kanchrapara"
	        },
	        {
	            "id": "1128703",
	            "name": "Barrackpore"
	        },
	        {
	            "id": "1135723",
	            "name": "Howrah"
	        },
	        {
	            "id": "1135543",
	            "name": "Halisahar"
	        },
	        {
	            "id": "1132123",
	            "name": "Dainhat"
	        },
	        {
	            "id": "1132303",
	            "name": "Dalkhola"
	        },
	        {
	            "id": "1132483",
	            "name": "Darjeeling"
	        },
	        {
	            "id": "1140583",
	            "name": "Mathabhanga"
	        },
	        {
	            "id": "1134823",
	            "name": "Guskara"
	        },
	        {
	            "id": "1135003",
	            "name": "Habra"
	        },
	        {
	            "id": "1135183",
	            "name": "Haldia"
	        },
	        {
	            "id": "1135363",
	            "name": "Haldibari"
	        },
	        {
	            "id": "1136083",
	            "name": "Islampur"
	        },
	        {
	            "id": "1136263",
	            "name": "Jalpaiguri"
	        },
	        {
	            "id": "100199",
	            "name": "Jangipur"
	        },
	        {
	            "id": "1136623",
	            "name": "JaynagarMazilpur"
	        },
	        {
	            "id": "1136803",
	            "name": "Jhalda"
	        },
	        {
	            "id": "1136983",
	            "name": "Jhargram"
	        },
	        {
	            "id": "1129423",
	            "name": "Bhadreswar"
	        },
	        {
	            "id": "1137883",
	            "name": "Kalyani"
	        },
	        {
	            "id": "1139683",
	            "name": "Kulti"
	        },
	        {
	            "id": "1131763",
	            "name": "CoochBehar"
	        },
	        {
	            "id": "1126903",
	            "name": "AshoknagarKalyangarh"
	        },
	        {
	            "id": "100160",
	            "name": "North24Parganas"
	        },
	        {
	            "id": "30",
	            "name": "Kolkata"
	        },
	        {
	            "id": "1139503",
	            "name": "Krishnanagar"
	        },
	        {
	            "id": "1126363",
	            "name": "Alipurduar"
	        },
	        {
	            "id": "1126543",
	            "name": "Arambag"
	        },
	        {
	            "id": "1126723",
	            "name": "Asansol"
	        },
	        {
	            "id": "1127083",
	            "name": "Baharampur"
	        },
	        {
	            "id": "1127623",
	            "name": "Balurghat"
	        },
	        {
	            "id": "1127803",
	            "name": "Bankura"
	        },
	        {
	            "id": "1128523",
	            "name": "Bardhaman"
	        },
	        {
	            "id": "1128883",
	            "name": "Baruipur"
	        },
	        {
	            "id": "1129063",
	            "name": "Basirhat"
	        },
	        {
	            "id": "1129243",
	            "name": "Beldanga"
	        },
	        {
	            "id": "1129963",
	            "name": "Birnagar"
	        },
	        {
	            "id": "1130323",
	            "name": "BolpurSantiniketan"
	        },
	        {
	            "id": "1130863",
	            "name": "Chakdaha"
	        },
	        {
	            "id": "1131583",
	            "name": "Contai"
	        }
	    ]
      	
    }
}